import { Component } from '@angular/core';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { NavController, NavParams } from 'ionic-angular';
import { AlphabetizedCollection } from '../../models/alphabetized-collection';
import { Chapter } from '../../models/Chapter';
import { Entry } from '../../models/entry';
import { DirectoryService } from '../../providers/directory-service';
import { DesktopService } from "../../providers/desktop-service";

@Component({
  selector: 'page-browse-category',
  templateUrl: 'browse-category.html'
})
export class BrowseCategoryPage {

    public chapter: Chapter;
    public entry: Entry;
    public entries: Entry[];

    public alphabetized: AlphabetizedCollection<Entry>;

    constructor(
        public analytics: FirebaseAnalytics,
        public directoryService: DirectoryService,
        public navCtrl: NavController,
        public navParams: NavParams,
        private desktopService: DesktopService,
    ) {
        this.chapter = navParams.get('chapter');
        this.entry = navParams.get('entry');
        this.entries = navParams.get('entries');

        this.alphabetized = new AlphabetizedCollection(this.entries, entry => {
            return entry.title.charAt(0).toUpperCase();
        }, (a, b) => {
            const title_a = AlphabetizedCollection.removeSpecialCharsAndLowercase(a.title);
            const title_b = AlphabetizedCollection.removeSpecialCharsAndLowercase(b.title);

            if (title_a < title_b) return -1;
            if (title_a > title_b) return 1;
            return 0;
        });
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Chapter');

        if (this.chapter) {
            const {id, title} = this.chapter;
            this.analytics.logEvent('chapter_view', {
                category_id: id || '',
                category_title: title || '',
            });
        }
    }

    public showEntry(entry: Entry) {
        this.directoryService.showEntry(entry);
    }

}



// WEBPACK FOOTER //
// ./src/pages/browse-category/browse-category.ts